import { Box, Typography, Button, Stack, Container, IconButton } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { useDevice } from '../../hooks/useResponsive';
import { getInspectionBookingDetails } from '../../server/api/inspectionBooking';

export default function PaymentFail() {
  const navigate = useNavigate();
  const { isMobile } = useDevice();
  const params = useParams();
  const dispatch = useDispatch();

  const { inspectionBookingSingleViewDetails } = useSelector((state) => ({
    inspectionBookingSingleViewDetails: state.Inspection.inspectionBookingSingleViewDetails,
    loading: state.Inspection.loading,
  }));

  useEffect(() => {
    const credentials = {
      bookingId: params?.id,
      dispatch,
    };
    dispatch(getInspectionBookingDetails(credentials));
  }, [dispatch, params?.id]);

  console.log('inspectionBookingSingleViewDetails>>.', inspectionBookingSingleViewDetails);

  return (
    <Box className="bg-light ">
      <Container
        maxWidth="xl"
        sx={{
          padding: isMobile ? 'unset' : '0px 0px 500px 0px !important',
          position: 'relative',
          minHeight: !isMobile && '100vh',
          backgroundColor: '#f0f1f3',
        }}
      >
        <Box
          sx={{
            width: '100%',
            height: isMobile ? 150 : 500,
            backgroundImage: 'url(/assets/images/Inspection/VerifyBanner.webp)',
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
          }}
        />
        <Container
          maxWidth="md"
          sx={{
            position: 'absolute',
            top: isMobile ? 0 : '15%',
            left: '50%',
            transform: 'translateX(-50%)',
            borderRadius: isMobile ? 0 : '24px',
            backgroundColor: '#FFFFFF',
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            alignItems: 'center',
            p: isMobile ? 0 : '30px !important',
            pb: 4,
          }}
        >
          {!isMobile && (
            <Stack
              direction="row"
              alignItems="left"
              onClick={() => navigate(-1)}
              spacing={isMobile ? 0.5 : 1.2}
              sx={{ cursor: 'pointer' }}
              width="100%"
            >
              <IconButton size="small" sx={{ p: 0 }}>
                <ArrowBackIosNewIcon sx={{ fontSize: '12px', color: '#121212' }} />
              </IconButton>
              <Typography fontSize={14} fontWeight={500} color="#121212">
                Back
              </Typography>
            </Stack>
          )}
          <Box
            sx={{
              maxWidth: '420px',
              width: isMobile ? '100%' : '100%',
              minHeight: {
                xs: '75vh', // mobile
                sm: '600px', // tablet
                md: '500px', // desktop
              },
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'space-between',
              textAlign: 'center',
              backgroundColor: 'white',

              p: 2,
            }}
          >
            <Stack alignItems="center">
              {/* Tick Image */}
              <Box
                component="img"
                src="/assets/images/Inspection/faile.png"
                alt="Booking Confirmed"
                sx={{ width: 240, height: 240, mb: 2 }}
              />
              {/* Title */}
              <Typography
                fontSize={24}
                sx={{
                  fontWeight: 600,
                  color: '#FD5661', // Green
                  mb: 1,
                }}
              >
                Booking Failed{' '}
              </Typography>

              {/* Subtitle */}
              <Typography fontSize={14} sx={{ color: '#121212' }}>
                Your Payment of ₹{' '}
                <Box component="span" sx={{ fontWeight: 800 }}>
                  ₹
                  {inspectionBookingSingleViewDetails?.vehicle_details?.brand?.inspection_charge?.offer_price ??
                    inspectionBookingSingleViewDetails?.vehicle_details?.brand?.inspection_charge?.price ??
                    0}
                </Box>{' '}
                Successfully Received <br />
                and booking for {inspectionBookingSingleViewDetails?.vehicle_details?.brand?.name || '---'} has
                confirmed.
              </Typography>
            </Stack>

            {/* Go Back Button */}
            <Stack direction="row" spacing={2} width="100%">
              <Button
                type="submit"
                onClick={() => navigate(-1)}
                fullWidth
                sx={{
                  textTransform: 'none',
                  fontWeight: 700,
                  fontSize: isMobile ? 14 : 14,
                  borderRadius: '50px',
                  width: '100%',

                  background: 'linear-gradient(90deg, #FF9910 0%, #F16400 100%)',
                  color: 'white',
                  '&:hover': {
                    background: 'linear-gradient(90deg, #F16400 0%, #FF9910 100%)',
                  },
                  '&.Mui-disabled': {
                    background: '#ccc',
                    color: '#666',
                  },
                }}
              >
                Retry
              </Button>
              <Button
                onClick={() => navigate('/inspection-booking')}
                variant="outlined"
                sx={{
                  borderRadius: '50px',
                  borderColor: '#F16400',
                  color: '#F16400',
                  width: '100%',
                  fontWeight: 600,
                  textTransform: 'none',
                  '&:hover': {
                    borderColor: '#F16400',
                    backgroundColor: 'rgba(255,153,16,0.05)',
                  },
                }}
              >
                Go Back
              </Button>
            </Stack>
          </Box>
        </Container>
      </Container>
    </Box>
  );
}
